import React, { useState, useEffect } from "react";
import { useListAccountMasterv2Query } from "../../../redux/apis/accountMaster.api";
import { useStateList } from "./HandleInvoiceStateProvider";
import { useSelector } from "react-redux";

function UseLedgerAccount({ Type }) {
  const [cashAccount, setCashAccount] = useState([]);
  const [bankAccount, setBankAccount] = useState([]);
  const [expenceAccNames, setExpenceAccNames] = useState([]);
  const [expenceAllAcc, setExpenceAllAcc] = useState([]);

  const { partyType, setAccNames } = useStateList();
  const getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  const companyType =
    getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;

  const { data: ledgerList } = useListAccountMasterv2Query();

  // function comparePathWithId(pathString, ...ids) {
  //   const pathArray = pathString?.replace(/^\/|\/$/g, "").split("/");
  //   const pathWithoutAccountId = pathArray?.slice(0, -1);
  //   return ids.some((id) => pathWithoutAccountId?.includes(id.toString()));
  // }
  
  function comparePathWithId(pathString = "", ...ids) {
    const pathArray = pathString.replace(/^\/|\/$/g, "").split("/");
    const pathWithoutAccountId = pathArray.length > 1 ? pathArray.slice(0, -1) : pathArray;
    return ids.some((id) => pathWithoutAccountId.includes(id.toString()));
  }

  const listAccounts = () => {
    if (!ledgerList) return;

    let allAccount = [];
    let cashAccountArr = [];
    let bankAccountArr = [];
    let expenceAccArr = [];
    let expenceAllAccArr = [];

    const filteredLedgerList = ledgerList?.filter(
      (item) =>
        item?.accountsid !== 12 &&
        (companyType !== 1 ||
          (item.accountsid !== 32 &&
            item.accountsid !== 33 &&
            ![2, 4, 5].includes(item.tax_type)))
    );

    filteredLedgerList?.forEach((ele) => {
      let groupName = ele?.accountgroupname
        ?.replace(/([a-z])([A-Z])/g, "$1 $2")
        ?.trim();
      if (ele.accountsid !== 24 && ele.accountsid !== 23) {
        allAccount.push({
          label: ele.accountname,
          value: ele.accountsid,
          groupName,
        });
      }
    });

    filteredLedgerList?.forEach((ele) => {
      let groupName = ele.accountgroupname
        ?.replace(/([a-z])([A-Z])/g, "$1 $2")
        ?.trim();

      if (comparePathWithId(ele.path, 17, 29)) {
        bankAccountArr.push({
          label: ele.accountname,
          value: ele.accountsid,
          groupName,
        });
      }

      if (comparePathWithId(ele.path, 16)) {
        cashAccountArr.push({
          label: ele.accountname,
          value: ele.accountsid,
          groupName,
        });
      }

      if (
        (Type === "Sales" || partyType === "CUSTOMER") &&
        comparePathWithId(ele.path, 19, 22)
      ) {
        expenceAccArr.push({
          label: ele.accountname,
          value: ele.accountsid,
          groupName,
        });
      }

      if (
        (Type === "Purchase" || partyType === "SUPPLIER") &&
        comparePathWithId(ele.path, 21, 23)
      ) {
        expenceAccArr.push({
          label: ele.accountname,
          value: ele.accountsid,
          groupName,
        });
      }
      if (!comparePathWithId(ele.path, 7, 15,17,29,16)) {
        expenceAllAccArr.push({
          label: ele.accountname,
          value: ele.accountsid,
          groupName,
        });
      }
    });

    // Update states
    setExpenceAccNames(expenceAccArr);
    setCashAccount(cashAccountArr);
    setBankAccount(bankAccountArr);
    setAccNames(allAccount);
    setExpenceAllAcc(expenceAllAccArr)
  };

  useEffect(() => {
    listAccounts();
  }, [ledgerList, Type, partyType]); // Dependencies for re-execution

  return { cashAccount, bankAccount, expenceAccNames ,expenceAllAcc};
}

export default UseLedgerAccount;
